/**
 * @param {object} state
 * @param {object} detail
 */
const addDetail = (state, detail) => {
  state.details.push(detail)
}

/**
 * @param {object} state
 * @param {object} detail
 */
const updateDetail = (state, detail) => {
  const index = state.details.findIndex(
    detailState => detailState.id === detail.id
  )

  Object.assign(state.details[index], detail)
}

/**
 * @param {object} state
 * @param {number} detailId
 */
const deleteDetail = (state, detailId) => {
  const index = state.details.findIndex(detail => detail.id === detailId)
  state.details.splice(index, 1)
}

/**
 * @type {object}
 */
const mutations = {
  addDetail,
  updateDetail,
  deleteDetail
}

export default mutations
